/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { jsx } from 'theme-ui'
import { RightAngle } from './vectors'

export const PacManBottom = ({ ...props }) => {
  return (
    <>
      <RightAngle
        sx={{
          position: 'absolute',
          width: '55%',
          bottom: -1,
        }}
        {...props}
        primary={props.color || 'white'}
      />
      <RightAngle
        flip
        sx={{
          position: 'absolute',
          width: '55%',
          right: 0,
          bottom: -1,
        }}
        {...props}
        primary={props.color || 'white'}
      />
    </>
  )
}

export default PacManBottom
